// The first read after a fresh sign-in (Robert, 2026-10-28 1:12 PM). Sign out, sign back in: the app reads at once,
// and the database can still be taking up the new sign-in, so it refuses that first read ("Missing or insufficient
// permissions"). Try Again always worked. Now the read waits and tries again on its own before any error shows.
// Only a refusal is retried. Any other error shows at once, as before.

import { errorCode } from "./firebase";

/** The waits between tries, in ms: two more tries in about three seconds. */
export const SIGN_IN_WAITS: readonly number[] = [800, 2000];

const sleepMs = (ms: number): Promise<void> => new Promise((r) => setTimeout(r, ms));

export async function retryRefused<T>(task: () => Promise<T>, waits: readonly number[] = SIGN_IN_WAITS, sleep: (ms: number) => Promise<void> = sleepMs): Promise<T> {
  for (let i = 0; ; i++) {
    try {
      return await task();
    } catch (e) {
      if (errorCode(e) !== "permission-denied" || i >= waits.length) throw e;
      await sleep(waits[i]!);
    }
  }
}
